import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Container, Row, ListGroup, Button, Form, Alert, Spinner } from 'react-bootstrap'
import { cpfMask, numberMask, cepMask, phoneWithDDDMask } from 'helpers/strings'
import DatePicker from 'react-datepicker'
import If from 'components/atoms/If'
import Typography from 'components/atoms/Typography'
import { cpf } from 'cpf-cnpj-validator'
import { DateTime } from 'luxon'
import * as publicCivilAction from 'store/modules/publicCivilAction/actions'
import { getStates } from 'helpers/mocks'
import 'react-datepicker/dist/react-datepicker.css'
import 'styles/datepicker.scss'
import './AcaoCivilPublica.scss'

import MaskedInput from 'react-maskedinput'

const typeAccount = [
  { option: 'ContaCorrente', value: 'Conta Corrente' },
  { option: 'Poupanca', value: 'Poupança' },
]

const banks = [
  { option: '001', value: '001-BANCO DO BRASIL S.A' },
  { option: '033', value: '033-BANCO SANTANDER S.A.' },
  { option: '104', value: '104-CAIXA ECONOMICA FEDERAL' },
  { option: '237', value: '237-BANCO BRADESCO S.A.' },
  { option: '341', value: '341-ITAU UNIBANCO S.A.' },
  { option: '399', value: '399-HSBC BANK BRASIL S.A.-BANCO MULTIPLO' },
  { option: '422', value: '422-BANCO SAFRA S.A.' },
  { option: '745', value: '745-BANCO CITIBANK S.A.' },
  { option: '748', value: '748-BANCO COOPERATIVO SICREDI S.A.' },
  { option: '999', value: '999-OUTROS (DIGITAR O NOME DO BANCO)' },
]

function AcaoCivilPublica({ props }) {
  const dispatch = useDispatch()
  const recipients = useSelector((state) => state.publicCivilAction)

  const [formValidated, setFormValidated] = useState(false)
  const [showWarning, setShowWarning] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [showList, setShowList] = useState(true)
  const [validityDate, setValidityDate] = useState(new Date())
  const [requiredBankData, setRequeridBankData] = useState(false)
  const [states, setStates] = useState([])
  const [otherBank, setOtherBank] = useState(false)
  const [code, setCode] = useState()
  const [customInput, setCustomInput] = useState('')
  const [recipientData, setRecipientData] = useState({
    name: '',
    cpfNumber: '',
    rg: '',
    phoneNumber: '',
    cellPhoneNumber: '',
    address: {
      handleResidential: '',
      numberAddress: '',
      district: '',
      zipCode: '',
      city: '',
      state: '',
    },
    bank: {
      bankName: '',
      agency: '',
      typeAccount: '',
      numberAccount: '',
      digitAccount: '',
      otherBank: '',
    },
  })

  useEffect(() => {
    dispatch(publicCivilAction.getRecipients())
    const dataStates = getStates()
    setStates(dataStates)
  }, [])

  useEffect(() => {
    if (recipients.updateRecipient.code) {
      setShowForm(false)
      setShowSuccess(true)
    }
  }, [recipients])

  const handleSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()

    const form = event.currentTarget
    if (form.checkValidity() && cpf.isValid(numberMask(recipientData.cpfNumber))) {
      const formattedValidityDate = DateTime.fromJSDate(validityDate).toFormat('yyyy-MM-dd')

      // TODO: Padronizar form payload conforme values da mutation
      const payload = {
        code: code,
        input: {
          street: recipientData.address.handleResidential,
          code: code,
          bank: recipientData.bank.bankName,
          other_bank: recipientData.bank.otherBank,
          agency: recipientData.bank.agency,
          account_type: recipientData.bank.typeAccount,
          account: recipientData.bank.numberAccount,
          digit: recipientData.bank.digitAccount,
          cpf: recipientData.cpfNumber,
          birth_date: formattedValidityDate,
          rg: recipientData.rg,
          phone: recipientData.phoneNumber,
          cell_phone: recipientData.cellPhoneNumber,
          address: recipientData.address.handleResidential,
          number: recipientData.address.numberAddress,
          neighborhood: recipientData.address.district,
          zipcode: recipientData.address.zipCode,
          city: recipientData.address.city,
          state: recipientData.address.state,
          info: navigator.appVersion,
          no_account: requiredBankData ? requiredBankData.toString() : '',
          email: '',
          name: recipientData.name,
          created_at: DateTime.now().toSQL(),
        },
      }

      dispatch(publicCivilAction.updateRecipient(payload))
      window.scrollTo(0, 600)
    }

    setFormValidated(true)
  }

  const checkRecipient = (recipient) => {
    setShowList(false)
    window.scrollTo(0, 600)
    if (recipient.created_at) {
      setShowWarning(true)
    } else {
      handleEdit('name', recipient.name)
      setCode(recipient.code)
      setShowForm(true)
    }
  }

  const handleDate = (date) => {
    const currentDate = new Date()
    const birthDate = DateTime.fromJSDate(date).toFormat('dd/MM/yyyy')
    let dateParts = birthDate.split('/')
    const dateFormated = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0])
    let d1 = DateTime.fromJSDate(dateFormated).toFormat('yyyy-MM-dd')
    let d2 = DateTime.fromJSDate(currentDate).toFormat('yyyy-MM-dd')

    if (d1 > d2) {
      setValidityDate(currentDate)
    } else {
      setValidityDate(date)
    }
  }

  const handleEdit = (prop, value) => {
    let tmp = {
      ...recipientData,
    }
    props = prop.split('.')

    if (prop === 'cpfNumber') {
      value = cpfMask(value)
    } else if (prop === 'rg') {
      value = numberMask(value)
    } else if (prop === 'address.zipCode') {
      value = cepMask(value)
    } else if (prop === 'phoneNumber' || prop === 'phoneNumber') {
      value = phoneWithDDDMask(value)
    } else if (prop === 'cellPhoneNumber' || prop === 'cellPhoneNumber') {
      value = phoneWithDDDMask(value, 16, true)
    } else if (prop === 'numberAccount' || prop === 'bank.numberAccount') {
      value = numberMask(value, 9)
    } else if (prop === 'agency' || prop === 'bank.agency') {
      value = numberMask(value, 4)
    } else if (prop === 'digitAccount' || prop === 'bank.digitAccount') {
      value = numberMask(value, 1)
    }

    if (props.length > 1) {
      tmp[props[0]][props[1]] = value
    } else {
      tmp[prop] = value
    }
    setRecipientData(tmp)
  }

  const handleFocus = () => {
    const maskedInput = <MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" size="20" />
    setCustomInput(maskedInput)
  }

  const changebank = (data) => {
    data !== '999' ? setOtherBank(false) : setOtherBank(true)
    handleEdit('bank.bankName', data)
  }

  const reset = () => {
    setShowList(true)
    setShowForm(false)
    setShowWarning(false)
  }

  return (
    <Container className="mt-5 mb-5">
      <If condition={showList}>
        <Row>
          <Col>
            <ListGroup as="ul">
              <ListGroup.Item as="li" active>
                Nome do Beneficiário
              </ListGroup.Item>
              {!recipients.recipientsData && recipients.loading && <Spinner className="my-4" animation="border" />}
              {Array.isArray(recipients.recipientsData) &&
                recipients.recipientsData.map((item, index) => (
                  <ListGroup.Item key={item.code} onClick={() => checkRecipient(item)} as="li">
                    {item.name}
                  </ListGroup.Item>
                ))}
            </ListGroup>
          </Col>
        </Row>
      </If>
      <If condition={showSuccess}>
        <Alert variant="success">
          <Alert.Heading>Olá {recipients.updateRecipient.name},</Alert.Heading>
          <Typography variant="p" color="secundary">
            {' '}
            suas informações foram encaminhadas à Unimed Curitiba e geraram o seguinte número de protocolo:{' '}
            <strong>{recipients.updateRecipient.protocol_number}</strong>{' '}
          </Typography>
          <Typography variant="p" color="secundary">
            <b>Você terá direito a uma restituição de R$ {recipients.updateRecipient.value} .</b>
          </Typography>
          <Typography variant="p" color="secundary">
            O <strong>depósito</strong> do valor na conta bancária de <strong>sua titularidade</strong> será realizado
            em <strong>até 10 (dez) dias úteis.</strong>
          </Typography>
          <Typography variant="p" color="secundary">
            ATENÇÃO: Caso ocorra irregularidade no preenchimento das informações, esta poderá acarretar o não pagamento
            do valor pela Unimed Curitiba no prazo e forma definidos.
          </Typography>
        </Alert>
      </If>

      <If condition={showWarning}>
        <Alert variant="warning">
          <p>
            {' '}
            CADASTRO JÁ EFETUADO! DÚVIDAS LIGAR PARA <a href="tel:08006422002">0800-642-2002</a>.
          </p>
        </Alert>
        <Button variant="link" onClick={() => reset()}>
          Voltar
        </Button>
      </If>

      <If condition={showForm}>
        <Form noValidate validated={formValidated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col>
              <Form.Label>Nome do Beneficiário:</Form.Label>
              <Form.Control
                type="text"
                required
                disabled
                value={recipientData.name || ''}
                onChange={(e) => handleEdit('name', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <Form.Label>RG:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.rg || ''}
                onChange={(e) => handleEdit('rg', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>

            <Col xs={12} lg={4}>
              <Form.Label>Telefone:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.phoneNumber || ''}
                onChange={(e) => handleEdit('phoneNumber', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>

            <Col xs={12} lg={4}>
              <Form.Label>Celular:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.cellPhoneNumber || ''}
                onChange={(e) => handleEdit('cellPhoneNumber', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={4} md="auto" className="mb-3 mb-lg-0">
              <Form.Group controlId="formCpfNumber">
                <Form.Label>CPF:</Form.Label>
                <Form.Control
                  type="text"
                  value={recipientData.cpfNumber}
                  required={true}
                  isInvalid={recipientData.cpfNumber.length > 0 && !cpf.isValid(numberMask(recipientData.cpfNumber))}
                  isValid={cpf.isValid(numberMask(recipientData.cpfNumber))}
                  onChange={(e) => handleEdit('cpfNumber', e.target.value)}
                />
                <Form.Control.Feedback type="invalid"> Por favor informe um CPF válido </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} lg={4}>
              <Form.Group controlId="formValidityDate">
                <Form.Label>Data de Nascimento:</Form.Label>

                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  title="Data de Nascimento"
                  selected={validityDate || new Date()}
                  maxDate={new Date()}
                  required={true}
                  onFocus={() => handleFocus()}
                  onChange={(date) => handleDate(date)}
                  customInput={customInput}
                />

                <Form.Control.Feedback type="invalid">Por favor, informe uma data valida</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={9}>
              <Form.Label>Endereço:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.address.handleResidential || ''}
                onChange={(e) => handleEdit('address.handleResidential', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>

            <Col xs={12} lg={3}>
              <Form.Label>Número:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.address.numberAddress || ''}
                onChange={(e) => handleEdit('address.numberAddress', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <Form.Label>Bairro:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.address.district || ''}
                onChange={(e) => handleEdit('address.district', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>

            <Col xs={12} lg={4}>
              <Form.Label>Cep:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.address.zipCode || ''}
                onChange={(e) => handleEdit('address.zipCode', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>

            <Col xs={12} lg={4}>
              <Form.Label>Cidade:</Form.Label>
              <Form.Control
                type="text"
                required
                value={recipientData.address.city || ''}
                onChange={(e) => handleEdit('address.city', e.target.value)}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <Form.Group controlId="select-state">
                <Form.Label>Estado: </Form.Label>

                <Form.Control required as="select" onChange={(e) => handleEdit('address.state', e.target.value)}>
                  <option value="" selected disabled hidden>
                    Selecione
                  </option>
                  {states.map((item, index) => (
                    <option key={index} value={item.option}>
                      {item.value}
                    </option>
                  ))}
                </Form.Control>

                <Form.Control.Feedback type="invalid">Por favor, escolha um estado.</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Typography variant="p" color="primary" cssClass="mb-3">
            <b>DADOS BANCÁRIOS</b> <br />
            <b>IMPORTANTE: não serão efetuados depósitos em conta bancária de titularidade de terceiros.</b>
          </Typography>

          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <Form.Group controlId="select-bank">
                <Form.Label>Banco</Form.Label>

                <Form.Control required={!requiredBankData} as="select" onChange={(e) => changebank(e.target.value)}>
                  <option value="" selected disabled hidden>
                    Selecione
                  </option>
                  {banks.map((item, index) => (
                    <option key={index} value={item.option}>
                      {item.value}
                    </option>
                  ))}
                </Form.Control>

                <Form.Control.Feedback type="invalid"> Por favor, escolha um banco.</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <If condition={otherBank}>
              <Col className="mb-3" xs={12} lg={12}>
                <Form.Label>Nome do banco (somente no caso de banco não presente na lista acima): </Form.Label>
                <Form.Control
                  type="text"
                  required={!requiredBankData}
                  value={recipientData.bank.otherBank || ''}
                  onChange={(e) => handleEdit('bank.otherBank', e.target.value)}
                />
                <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
              </Col>
            </If>
            <Col xs={12} lg={4}>
              <Form.Label>Agência (sem o dígito):</Form.Label>
              <Form.Control
                type="text"
                required={!requiredBankData}
                value={recipientData.bank.agency || ''}
                onChange={(e) => handleEdit('bank.agency', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>
            <Col xs={12} lg={4}>
              <Form.Group controlId="select-bank">
                <Form.Label>Tipo de Conta</Form.Label>

                <Form.Control
                  required={!requiredBankData}
                  as="select"
                  onChange={(e) => handleEdit('bank.typeAccount', e.target.value)}
                >
                  <option value="" selected disabled hidden>
                    Selecione
                  </option>
                  {typeAccount.map((item, index) => (
                    <option key={index} value={item.option}>
                      {item.value}
                    </option>
                  ))}
                </Form.Control>

                <Form.Control.Feedback type="invalid">Por favor, escolha um tipo de conta.</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={6}>
              <Form.Label>Número da Conta Bancária (sem o dígito):</Form.Label>
              <Form.Control
                type="text"
                required={!requiredBankData}
                value={recipientData.bank.numberAccount || ''}
                onChange={(e) => handleEdit('bank.numberAccount', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>
            <Col xs={12} lg={6}>
              <Form.Label>Dígito da Conta Corrente:</Form.Label>
              <Form.Control
                type="number"
                required={!requiredBankData}
                min="1"
                max="9"
                value={recipientData.bank.digitAccount || ''}
                onChange={(e) => handleEdit('bank.digitAccount', e.target.value)}
              />
              <Form.Control.Feedback type="invalid"> Preenchimento obrigatório. </Form.Control.Feedback>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <Form.Group controlId="dataUpdate">
                <Form.Check
                  type="checkbox"
                  checked={requiredBankData}
                  onChange={() => setRequeridBankData(!requiredBankData)}
                  label="Não possuo conta bancária"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button className="mt-4 mb-5" variant="outline-primary" size="lg" type="submit">
                Enviar
              </Button>
            </Col>
          </Row>
        </Form>

        {recipients.errorUpdateRecipient && (
          <Alert variant="danger">
            <p>Ops... Erro ao realizar cadastro, tente novamente mais tarde!</p>
          </Alert>
        )}
        <Button variant="link" onClick={() => reset()}>
          Voltar
        </Button>
      </If>
    </Container>
  )
}

export default AcaoCivilPublica
